import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=796d981e&"
import script from "./Quote.vue?vue&type=script&lang=js&"
export * from "./Quote.vue?vue&type=script&lang=js&"
import style0 from "./Quote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Quote.vue"
export default component.exports